import React from "react";
import { QuestionListItem } from "service/exercise";
import style from "./index.module.scss";
import _ from "underscore";
import { toFixedNumber } from "service/service";

interface ExerciseTopicsButtonsProps {
    data: QuestionListItem[];
    onAdd: () => void;
    onCloneTopic: () => void;
    onCloneExercise: () => void;
}

export default function ExerciseTopicsButtons({
    data,
    onAdd,
    onCloneTopic,
    onCloneExercise
}: ExerciseTopicsButtonsProps) {
    const newData = data.map(item => (item.score ? Number(item.score) : 0));
    const totalScore = _.reduce(
        newData,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    return (
        <div className={style.root}>
            <div className={style.count}>
                共 {data.length !== 0 ? data.length : 0} 题，{" "}
                {toFixedNumber(totalScore)} 分
            </div>

            <div className={style.buttons}>
                <button className={style.add} onClick={onAdd}>
                    添加题目
                </button>
                <button className={style.pick} onClick={onCloneTopic}>
                    选择题目
                </button>
                <button className={style.clone} onClick={onCloneExercise}>
                    复制练习
                </button>
            </div>
        </div>
    );
}
